import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { SensoryProvider } from './context/SensoryContext';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PortfolioPage from './pages/PortfolioPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import Header from './components/Header';
import Footer from './components/Footer';
import SensoryPanel from './components/SensoryPanel';
import ScrollToTop from './components/ScrollToTop';

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    // Keyed wrapper replays the page fade-in on every route change.
    <div className="page" key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/portfolio" element={<PortfolioPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <SensoryProvider>
      <Router>
        <ScrollToTop />
        <a href="#main" className="skip-link">
          Skip to content
        </a>
        <div className="app">
          <Header />
          <main id="main" tabIndex={-1}>
            <AnimatedRoutes />
          </main>
          <Footer />
          <SensoryPanel />
        </div>
      </Router>
    </SensoryProvider>
  );
}

export default App;
